// copied from: https://github.com/quisido/react-innertext/blob/master/src/index.ts
import { type ReactElement, type ReactNode } from 'react';

interface InnerText {
  (jsx: ReactNode): string;
}

type ReactElementWithChildren = ReactElement<{ children?: ReactNode }>;

const hasProps = (jsx: ReactNode): jsx is ReactElement => Object.prototype.hasOwnProperty.call(jsx, 'props');
const hasChildren = (jsx: ReactElement): jsx is ReactElementWithChildren => Object.prototype.hasOwnProperty.call(jsx.props, 'children');

const reduceJsxToString = (previous: string, current: ReactNode): string => previous + innerText(current);

export const innerText: InnerText = (jsx: ReactNode): string => {
  // Empty
  if (jsx === null || typeof jsx === 'boolean' || jsx === undefined) {
    return '';
  }

  // Numeric children.
  if (typeof jsx === 'number') {
    return jsx.toString();
  }

  // String literals.
  if (typeof jsx === 'string') {
    return jsx;
  }

  // Array of JSX.
  if (Array.isArray(jsx)) {
    return jsx.reduce<string>(reduceJsxToString, '');
  }

  // Children prop.
  if (hasProps(jsx) && hasChildren(jsx)) {
    return innerText(jsx.props.children);
  }

  // Default
  return '';
};
